import { render, staticRenderFns } from "./ModalProvince.vue?vue&type=template&id=fda99ca0&scoped=true"
import script from "./ModalProvince.vue?vue&type=script&lang=js"
export * from "./ModalProvince.vue?vue&type=script&lang=js"
import style0 from "./ModalProvince.vue?vue&type=style&index=0&id=fda99ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda99ca0",
  null
  
)

export default component.exports